import { WidgetInput } from '@components/MainWidget/common/widgetInput'
import { WidgetComponents } from '@components/MainWidget/widgetRegistry'
import { INPUT_PLACEHOLDER, PUC_WIDGET, WIDGET_CTA_FALLBACK_PUC } from '@components/MainWidget/common/commonConstants'
import styles from '@components/MainWidget/common/commonStyles.module.scss'
import { WidgetCommonProps } from '@components/MainWidget/common/commonInterface'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { useWidgetContext } from '@context/userWidgetProps'

const PucWidget = ({
  regexPatternsData,
  widgetHeading,
  widgetCtaText,
  segmentEventCommonProperties,
  KeyFeatures,
  isAckoDrive = false,
  setOnWidgetFloaterClick,
}: WidgetCommonProps) => {
  const {
    widgetModal,
    setWidgetModal,
    vehicleData,
    setVehicleData,
    regNo,
    setRegNo,
    show,
    userData,
    phone,
    setPhone,
    setUserLoggedIn,
    isLoggedIn,
  } = useWidgetContext()

  return (
    <>
      <div className={`${show ? styles.isShowActive : ''}`}>
        <WidgetInput
          segmentEventCommonProperties={segmentEventCommonProperties}
          widgetHeading={widgetHeading}
          widgetDefaultHeading={widgetHeading}
          inputPlaceHolder={INPUT_PLACEHOLDER}
          widgetCTA={widgetCtaText}
          widgetCTAFallback={WIDGET_CTA_FALLBACK_PUC}
          regexPatternsData={regexPatternsData}
          setWidgetModal={setWidgetModal}
          setVehicleData={setVehicleData}
          vehicleData={vehicleData}
          setRegNo={setRegNo}
          regNo={regNo}
          widgetType={PUC_WIDGET}
          isAckoDrive={isAckoDrive}
          setOnWidgetFloaterClick={setOnWidgetFloaterClick}
          userData={userData}
          phone={phone}
          setPhone={setPhone}
          setUserLoggedIn={setUserLoggedIn}
          isLoggedIn={isLoggedIn}
          show={show}
        />
      </div>
      <PropertyControlledComponent fallback={null} controllerProperty={widgetModal}>
        <WidgetComponents
          widgetType={PUC_WIDGET}
          vehicleData={vehicleData}
          regNo={regNo}
          setWidgetModal={setWidgetModal}
          KeyFeatures={KeyFeatures}
          segmentEventCommonProperties={segmentEventCommonProperties}
          setRegNo={setRegNo}
          setVehicleData={setVehicleData}
        />
      </PropertyControlledComponent>
    </>
  )
}

export default PucWidget
